import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: '20px',
  padding: '44px 34px',
  width: '100%',
  maxWidth: '450px',
})); 
